import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/desa/$slug/laporan')({
  component: () => <Outlet />,
})
